// import store from '../store/modules/courseAndProject.js'
import that from "../main";

export default {
     dashboard:()=>{
      return [
        // {
        //   target: '.md-autocomplete',  // We're using document.querySelector() under the hood
        //   content: `您可以选择搜索这里查询想要资源`,
        // },
        // {
        //   target: '.goHome',  // We're using document.querySelector() under the hood
        //   content: `请可以点击这里回到首页`,
        //   params: {
        //     placement: 'bottom'
        //   }
        // },
        // {
        //   target: '.notice',
        //   content: '这里是通知页面哦!'
        // },
        {
          target: '.help',
          content: '点击帮助页面!'
        },
        // {
        //   target: '.vip',
        //   content: '此处为会员区域',
        //   params: {
        //     placement: 'top'
        //   }
        // },
        {
          target: '.aboutMy',
          content: '此处可以查看个人账号信息,平台锁屏幕,以及退出平台',
          params: {
            placement: 'top'
          }
        },
        // {
        //   target: '.modelResourceLibrary',
        //   content: '模型资源库'
        // },
        // {
        //   target: '.soure',
        //   content: '课程'
        // },
        // {
        //   target: '.userStatistics',
        //   content: '用户统计'
        // },
        // {
        //   target: '.partners',
        //   content: '合作伙伴'
        // },
        // {
        //   target: '.advertisingBanner',
        //   content: '广告区域'
        // },
        {
          target: '.recentUpdates',
          content: '最近更新'
        },

        {
          target: '.trainingRoomStepByStep',
          content: '实训室踩点'
        },
        {
          target: '.technology',
          content: '对应仿真实训使用情况'
        },
      ]
     },
     design:()=>{
      return [
      //   {
      //   target: '.btnGuide',  // We're using document.querySelector() under the hood
      //   content: `您可以选择这里关闭或打开向导`,
      //   before: type => new Promise((resolve, reject) => {
      //     resolve('foo')
      //   })
      // },
      {
        target: '.btnClass',  // We're using document.querySelector() under the hood
        content: `请选择要编辑的课程,如果课程不存在,请联系管理员新增该课程`,
        params: {
          placement: 'right'
        },
        before: type => new Promise((resolve, reject) => {
          resolve('foo')
        })
      },
      {
        target: '.btnAdd',
        content: '如没有您要编辑的项目节点(章/项目/情景),可以通过这里新增该节点',
        before: type => new Promise((resolve, reject) => {
          that.$EventBus.$emit('showDialogs',false)
          resolve('foo')
        })
      },
      {
        target: '.oneTabs',
        content: '请填写项目的基本信息,项目信息必须填写,负责人必须先注册为系统用户',
        params: {
          placement: 'top'
        },
        before: type => new Promise((resolve, reject) => {
          that.$EventBus.$emit('showDialogs',true)

          let timers =   setTimeout(()=>{
            resolve('foo')
            clearTimeout(timers)
          },200)
        })

      },
      {
        target: '.tabScene1',
        content: '项目中所用到的场景列表,一个项目中可以有多个场景,在这里维护的场景列表可以在任务中选择',
        params: {
          placement: 'top'
        },
        before: type => new Promise((resolve, reject) => {
          let data = '2'
          that.$EventBus.$emit('onSetGuideTabs',data)
          let timers =   setTimeout(()=>{
            resolve('foo')
            clearTimeout(timers)
          },200)
        })
      },
      {
        target: '.btnSceneAdd',
        content: '增加一个新场景列表',
        before: type => new Promise((resolve, reject) => {
          resolve('foo')
        })
      },
      {
        target: '.btnSceneEdit',
        content: '进入三维编辑器',
        before: type => new Promise((resolve, reject) => {
          resolve('foo')
        })
      },
      {
        target: '.copyScene',
        content: '拷贝一个场景',
        before: type => new Promise((resolve, reject) => {
          resolve('foo')
        })
      },
      {
        target: '.SceneEdit',
        content: '对场景信息进行编辑',
        before: type => new Promise((resolve, reject) => {
          that.$EventBus.$emit('showDialogs',true)
          resolve('foo')
        })
      },
      {
        target: '.btnSceneDel',
        content: '删除一个场景',
        before: type => new Promise((resolve, reject) => {
          that.$EventBus.$emit('showDialogs',true)
          let timers =   setTimeout(()=>{
            resolve('foo')
            clearTimeout(timers)
          },200)
  
    
        })
      },
      {
        target: '.btnEdit',
        content: '编辑该项目节点(章/项目/情景)',
        params: {
          placement: 'top'
        },
        before: type => new Promise((resolve, reject) => {
          that.$EventBus.$emit('showDialogs',false)
          that.$EventBus.$emit('hiddenDialogs',false)
          resolve('foo')
        })
      },
      {
        target: '.btnProjectDel',
        content: '删除该项目节点(章/项目/情景)',
        params: {
          placement: 'top'
        },
        before: type => new Promise((resolve, reject) => {
          resolve('foo')
        })
      },
      {
        target: '.lstProject',
        content: '这里是该课程的目录结构,在这里可以选中要编辑的某个项目节点(章/项目/情景)',
        before: type => new Promise((resolve, reject) => {
          resolve('foo')
        })
      },
      {
        target: '.lstTask',
        content: '这里是该项目节点(章/项目/情景)的子节点列表,即节/任务 列表',
        params: {
          placement: 'right'
        },
        before: type => new Promise((resolve, reject) => {
          resolve('foo')
        })
      },
      {
        target: '.btnFlow',
        content: '进入任务节点的流程编辑器',
        before: type => new Promise((resolve, reject) => {
          resolve('foo')
        })
      },
      {
        target: '.copyTask',
        content: '任务节点的复制(节/任务)',
        before: type => new Promise((resolve, reject) => {
          resolve('foo')
        })
      },
      {
        target: '.editTask',
        content: '任务节点的编辑(节/任务)',
        before: type => new Promise((resolve, reject) => {
          resolve('foo')
        })
      },
      {
        target: '.btnTaskDel',
        content: '删除某一任务节点(节/任务)',
        before: type => new Promise((resolve, reject) => {
          resolve('foo')
        })
      },
      {
        target: '.btnTaskAdd',
        content: '新增一个任务节点(节/任务)',
        params: {
          placement: 'left'
        },
        before: type => new Promise((resolve, reject) => {
          resolve('foo')
        })
      },
      {
        target: '.btnClassPub',
        content: '课程所有项目编辑完成后,可以发布该课程,请求系统引擎编译仿真课程产品',
        before: type => new Promise((resolve, reject) => {
          resolve('foo')
        })
      }]
     },
     //课程编辑
     course:()=>{
      return [
        {
          target: '.coursePagesize',
          content: '切换可更改课程列表查询的条数',
          before: type => new Promise((resolve, reject) => {
            resolve('foo')
          })
        },
        {
          target: '.courseQuery',
          content: '可查询对应课程信息',
          before: type => new Promise((resolve, reject) => {
            resolve('foo')
          })
        },
        {
          target: '.addButton',
          content: '增加课程',
          before: type => new Promise((resolve, reject) => {
            resolve('foo')
          })
        },
        {
          target: '.Editcourse',
          content: '编辑课程',
          before: type => new Promise((resolve, reject) => {
            resolve('foo')
          })
        },
        {
          target: '.delcourse',
          content: '删除课程',
          before: type => new Promise((resolve, reject) => {
            resolve('foo')
          })
        },
      
      ]

      
     },
     //课程管理
     newcourse:()=>{
        return [
          {
            target: '.Basic',
            content: '基础信息',
            before: type => new Promise((resolve, reject) => {
              that.$EventBus.$emit('unfoldS',0)
              resolve('foo')
            })
          },

          {
            target: '.courseName',
            content: '此处是输入课程的名称(必填)',
            before: type => new Promise((resolve, reject) => {
              resolve('foo')
            })
          },
          {
            target: '.Curriculum',
            content: '这里选择课程组织形式(必填)',
            before: type => new Promise((resolve, reject) => {
              resolve('foo')
            })
          },
          {
            target: '.uploadprofile',
            content: '这里上传课程相关的资料',
            before: type => new Promise((resolve, reject) => {
         
              resolve('foo')
            })
          },
          {
            target: '.Courseclassification',
            content: '课程分类(对于不同的学习专业进行了分类)',
            before: type => new Promise((resolve, reject) => {
              that.$EventBus.$emit('unfoldS',1)
              resolve('foo')
            })
          },
          {
            target: '.Usecourse',
            content: '适用学校或企业',
            before: type => new Promise((resolve, reject) => {
              that.$EventBus.$emit('unfoldS',1)
              resolve('foo')
            })
          },
          {
            target: '.PresidingUnit',
            content: '主持单位或集团',
            before: type => new Promise((resolve, reject) => {
              resolve('foo')
            })
          },
        ]
     },
     devicelib:()=>{
      return [
        {
          target: '.addModel',
          content: '点击可上传模型',
          before: type => new Promise((resolve, reject) => {
            resolve('foo')
          })
        },
        {
          target: '.filterLabel',
          content: '此选项是对已有标签进行模型筛选',
          before: type => new Promise((resolve, reject) => {
            resolve('foo')
          })
        },
        {
          target: '.deviceFilter',
          content: '此选项是根据设备 角色 工具 场景去查询对应模型',
          before: type => new Promise((resolve, reject) => {
            resolve('foo')
          })
        },
        {
          target: '.specialityFilter',
          content: '此选项根据 前者具体的分类去查询对应模型',
          before: type => new Promise((resolve, reject) => {
            resolve('foo')
          })
        },
        {
          target: '.clearFilter',
          content: '清空下方输入框查询条件',
          before: type => new Promise((resolve, reject) => {
            resolve('foo')
          })
        },
      
        {
          target: '.filterValue',
          content: '请在此处输入查询模型的条件',
          before: type => new Promise((resolve, reject) => {
            resolve('foo')
          })
        },
        {
          target: '.modelList',
          content: '此处为当前模型,可点击',
          before: type => new Promise((resolve, reject) => {
            that.$EventBus.$emit('viewModel',false)
            resolve('foo')
          })
        },
        {
          target: '.viewModelTab',
          content: '模型基本信息,可编辑查看对应模型信息',
          before: type => new Promise((resolve, reject) => {
            that.$EventBus.$emit('viewModel',true)
            resolve('foo')
          })
        },
        {
          target: '.viewModePreview',
          content: '模型预览可查看当前模型信息',
          before: type => new Promise((resolve, reject) => {
            resolve('foo')
          })
        },
        {
          target: '.model_name',
          content: '此处为设备模型名称(必须填写)',
          before: type => new Promise((resolve, reject) => {
            resolve('foo')
          })
        },
        {
          target: '.model_category',
          content: '此处为设备模型类型选项(必须选择)',
          before: type => new Promise((resolve, reject) => {
            resolve('foo')
          })
        },
        {
          target: '.one_level_classify',
          content: '此处为设备模型具体分类,在添加或者编辑时候不能为空',
          before: type => new Promise((resolve, reject) => {
            resolve('foo')
          })
        },

        {
          target: '.tags',
          content: '此处为设备模型添加标签处',
          before: type => new Promise((resolve, reject) => {
            resolve('foo')
          })
        },

        {
          target: '.updateModel',
          content: '更新当前模型',
          before: type => new Promise((resolve, reject) => {
            resolve('foo')
          })
        },
        {
          target: '.downModel',
          content: '下载当前模型文件到本机',
          before: type => new Promise((resolve, reject) => {
            resolve('foo')
          })
        },
        {
          target: '.delModel',
          content: '删除当前模型',
          before: type => new Promise((resolve, reject) => {
            that.$EventBus.$emit('viewModel',false)
            resolve('foo')
          })
        },
      
      
      
      ]

      
     },
     resourceLibrary:()=>{
          return [
            // 
            {
              target: '.uploadmedium',
              content: '点击此处会上传媒体资源',
              before: type => new Promise((resolve, reject) => {
                that.$EventBus.$emit('addUploadMedium',false)
                resolve('foo')
              })
            },
            {
              target: '.mediumName',
              content: '此处是填写资源名称并且(必须填写)',
              before: type => new Promise((resolve, reject) => {
                that.$EventBus.$emit('addUploadMedium',true)
                // that.$EventBus.$emit('addUploadMedium',true)
                resolve('foo')
              })
            },
            {
              target: '.mediumType',
              content: '此处是选择资源的类型(必须选择此项)',
              before: type => new Promise((resolve, reject) => {
             
                resolve('foo')
              })
            },
            {
              target: '.mediumPagesize',
              content: '切换可更改媒体资源库展示的内容条数',
              before: type => new Promise((resolve, reject) => {
                that.$EventBus.$emit('addUploadMedium',false)
                resolve('foo')
              })
            },
            {
              target: '.mediumNameQurery',
              content: '可根据资源名称进行查询',
              before: type => new Promise((resolve, reject) => {
                resolve('foo')
              })
            },
            {
              target: '.viewMedium',
              content: '可跳转查看当前资源',
              before: type => new Promise((resolve, reject) => {
                resolve('foo')
              })
            },
            {
              target: '.viewMediumImg',
              content: '可放大查看当前资源信息二维码',
              before: type => new Promise((resolve, reject) => {
                resolve('foo')
              })
            },
            {
              target: '.editMedium',
              content: '可编辑当前资源信息',
              before: type => new Promise((resolve, reject) => {
                resolve('foo')
              })
            },
            {
              target: '.delMedium',
              content: '可删除当前资源信息',
              before: type => new Promise((resolve, reject) => {
                resolve('foo')
              })
            },

          ]
     },
     simclass:()=>{
          return [
            {
              target: '.filterCoure',
              content: '此处可筛选对应发布课程信息',
              before: type => new Promise((resolve, reject) => {
                resolve('foo')
              })
            },
            {
              target: '.white--text',
              content: '点击此处下载当前访问实训客户端',
              before: type => new Promise((resolve, reject) => {
                resolve('foo')
              })
            },
            {
              target: '.querySimulation',
              content: '回车查询当前仿真实训列表',
              before: type => new Promise((resolve, reject) => {
                resolve('foo')
              })
            },
           
            {
              target: '.modelClientWrap',
              content: '可打开当前仿真实训客户端',
              before: type => new Promise((resolve, reject) => {
                resolve('foo')
              })
            },


          ]
     },
     //模型申请
     applymod:()=>{
         return [
          {
            target: '.ModelBtnType',
            content: '根据设备类型查询申请信息',
            before: type => new Promise((resolve, reject) => {
              resolve('foo')
            })
          },
          {
            target: '.ModelBtnTypeType',
            content: '根据设备具体类型查询申请信息',
            before: type => new Promise((resolve, reject) => {
              resolve('foo')
            })
          },
          {
            target: '.clearModel',
            content: '点击清除筛选条件',
            before: type => new Promise((resolve, reject) => {
              resolve('foo')
            })
          },
          {
            target: '.valueFilter',
            content: '输入查询的名称',
            before: type => new Promise((resolve, reject) => {
              resolve('foo')
            })
          },
         ]
     },

     //模型审核
    auditmod:()=>{
        return [
         {
           target: '.ModelBtnType',
           content: '根据设备类型查询模型审核的信息',
           before: type => new Promise((resolve, reject) => {
             resolve('foo')
           })
         },
         {
           target: '.ModelBtnTypeType',
           content: '根据设备具体类型查询模型审核的信息',
           before: type => new Promise((resolve, reject) => {
             resolve('foo')
           })
         },
         {
           target: '.clearModel',
           content: '点击清除筛选条件',
           before: type => new Promise((resolve, reject) => {
             resolve('foo')
           })
         },
         {
           target: '.valueFilter',
           content: '输入查询的名称',
           before: type => new Promise((resolve, reject) => {
             resolve('foo')
           })
         },
        ]
    },

    //模型开发
    devmod:()=>{
          return [
           {
             target: '.ModelBtnType',
             content: '根据设备类型查询待开发模型信息',
             before: type => new Promise((resolve, reject) => {
               resolve('foo')
             })
           },
           {
             target: '.ModelBtnTypeType',
             content: '根据设备具体类型查询待开发模型信息',
             before: type => new Promise((resolve, reject) => {
               resolve('foo')
             })
           },
           {
             target: '.clearModel',
             content: '点击清除筛选条件',
             before: type => new Promise((resolve, reject) => {
               resolve('foo')
             })
           },
           {
             target: '.valueFilter',
             content: '输入查询的名称',
             before: type => new Promise((resolve, reject) => {
               resolve('foo')
             })
           },
          ]
    },

    // 编译申请
    applycomplie:()=>{
      return [
        {
          target: '.compilePageSize',
          content: '切换可更改编译申请展示的内容条数',
          before: type => new Promise((resolve, reject) => {
            resolve('foo')
          })
        },
        {
          target: '.valueFilter',
          content: '根据名称查找编译申请信息',
          before: type => new Promise((resolve, reject) => {
            resolve('foo')
          })
        },
       ]
    },

    
    // 编译审核
    auditcompile:()=>{
      return [
        {
          target: '.compilePageSize',
          content: '切换可更改编译申请展示的内容条数',
          before: type => new Promise((resolve, reject) => {
            resolve('foo')
          })
        },
        {
          target: '.valueFilter',
          content: '根据名称查找编译申请信息',
          before: type => new Promise((resolve, reject) => {
            resolve('foo')
          })
        },
        {
          target: '.agreeWith',
          content: '同意审核',
          before: type => new Promise((resolve, reject) => {
            resolve('foo')
          })
        },
        {
          target: '.refuse',
          content: '拒绝审核',
          before: type => new Promise((resolve, reject) => {
            resolve('foo')
          })
        },
        {
          target: '.withdraw',
          content: '撤回审核',
          before: type => new Promise((resolve, reject) => {
            resolve('foo')
          })
        },
        {
          target: '.republish',
          content: '重新发布',
          before: type => new Promise((resolve, reject) => {
            resolve('foo')
          })
        },

       ]
    },


    //标签管理
    tag:()=>{
      return [
        {
          target: '.addTag',
          content: '点击添加标签',
          before: type => new Promise((resolve, reject) => {
            resolve('foo')
          })
        },
        {
          target: '.queryTag',
          content: '根据输入的名称查询对应的标签',
          before: type => new Promise((resolve, reject) => {
            resolve('foo')
          })
        },
        {
          target: '.editTag',
          content: '点击此处编辑标签名称',
          before: type => new Promise((resolve, reject) => {
            resolve('foo')
          })
        },
        {
          target: '.delTag',
          content: '删除当前标签',
          before: type => new Promise((resolve, reject) => {
            resolve('foo')
          })
        },



      ]
    },

}